{
  "actions": "Dejanja",
  "hideButtonLabel": "Prikaži manj",
  "noTags": "Nič",
  "showAllButtonLabel": "Prikaž vse ({tagCount, number})"
}
